const UIkit = window.UIkit || {};
const modalCenter = document.querySelector('.ac180T-thematic-email-modal-center');
const modalClose = document.querySelector('.a-modal-close')
function postData (url, data) {
  return fetch(url + "/mailchimp/subscribe", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // 如果有需要的话，可以添加其他请求头
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .catch(error => {
      console.error('Error:', error);
      // 如果需要，你可以进一步处理错误
      throw error;
    });
}

var submitFormsAc180T = document.querySelectorAll(".mc-embedded-subscribe-form-box .mc-embedded-subscribe-form-ac180t");
var checkboxElAll = document.getElementsByName("form-checkbox");
var termsPrivacyEl = document.querySelector(".terms-privacy");
var errorResponseEl = document.querySelector(".mce-error-response");
var successResponseEl = document.querySelector(".mce-success-response");
// 请求的目标URL
const apiUrlAc180T = 'https://api.bluettipower.com/messageapi'; //正式环境
// const apiUrlAc180T = 'https://srv0.bluettipower.com/messageapi'; //测试环境


checkboxElAll.forEach((item) => {
  item.addEventListener("click", function (event) {
    let target = event.target;
    activeEl(target.checked, event.target);
  });
});

function activeEl (show, el) {
  if (show) {
    el.classList.remove("active");
    termsPrivacyEl.classList.add("hidden");
  } else {
    el.classList.add("active");
    termsPrivacyEl.classList.remove("hidden");
  }
}

if (submitFormsAc180T.length > 0) {
  submitFormsAc180T.forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      var emailValue = event.target.querySelector('[type="email"]').value;
      var tags = event.target.querySelector('[name="tags"]').value;
      var audienceId = event.target.querySelector('[name="audienceId"]').value;
      var submitButton = event.target.querySelector('[type="submit"]');
      // console.log('emailValue', emailValue);
      // console.log('tags', tags);
      if (emailValue == "") return;
      var checkboxEl = event.target.querySelector('[type="checkbox"]');
      var checkboxOff = checkboxEl.checked;

      activeEl(checkboxOff, checkboxEl);
      if (!checkboxOff) return;
      errorResponseEl.classList.add("hidden");
      successResponseEl?.classList.add("hidden");

      // 请求参数
      let requestData = {
        email: emailValue,
        audienceId: audienceId,
        tag: tags
      };

      submitButton.disabled = true;
      submitButton.classList.add('loading');
      postData(apiUrlAc180T, requestData)
        .then(data => {
          // 处理返回的数据
          if (data.code !== 0) {
            successResponseEl?.classList.add("hidden");
            errorResponseEl.classList.remove("hidden");
          } else {
            successResponseEl?.classList.remove("hidden");
            errorResponseEl.classList.add("hidden");
            event.target.querySelector('[type="email"]').value = "";
            UIkit.modal(modalCenter).show();
          }
        })
        .catch(error => {
          // 在这里处理错误，如果不需要额外处理，可以省略这一部分
          console.error('Error in main:', error);
        })
        .finally(() => {
          // 这里的代码会在请求成功或失败后都执行
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        });
    });
  });
}

modalClose.addEventListener("click", function () {
  UIkit.modal(modalCenter).hide();
});